
function getTimeDescription(unit, baseDesc) {
    const lastDigit = parseInt(unit.toString().slice(-1));

    if (unit == 1) {
        return baseDesc + 'ę';
    } else if ((unit > 20 || unit < 5) && (lastDigit > 1 && lastDigit < 5)) {
        return baseDesc + 'y';
    } else {
        return baseDesc;
    }
}
function countdown(display) {

    const countDownDate = Date.parse(display.getAttribute('datetime'));

    const daysContainer = display.querySelector('.counter__days');
    const hoursContainer = display.querySelector('.counter__hours');
    const minutesContainer = display.querySelector('.counter__minutes');
    const secondsContainer = display.querySelector('.counter__seconds');
    const daysDescription = display.querySelector('.counter__days-desc');
    const hoursDescription = display.querySelector('.counter__hours-desc');
    const minutesDescription = display.querySelector('.counter__minutes-desc');
    const secondsDescription = display.querySelector('.counter__seconds-desc');
    let x;

// Update the count down every 1 min
    if(daysContainer && hoursContainer && minutesContainer) {
        countDown();
        x = setInterval(countDown, 1000);
    }

     function countDown() {
         // Get today's date and time
         const now = new Date().getTime();

         // Find the distance between now and the count down date
         const distance = countDownDate - now;

         // Time calculations for days, hours, minutes and seconds
         const days = Math.floor(distance / (1000 * 60 * 60 * 24));
         const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
         const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
         const seconds = Math.floor((distance % (1000 * 60)) / 1000);

         let daysDesc = 'dni';
         let hoursDesc;
         let minutesDesc;
         let secondsDesc;

         if (days == 1) {
             daysDesc = 'dzień';
         };

         hoursDesc = getTimeDescription(hours, "godzin");
         minutesDesc = getTimeDescription(minutes, "minut");
         secondsDesc = getTimeDescription(seconds, "sekund");

         daysContainer.innerText =  days;
         hoursContainer.innerText = hours;
         minutesContainer.innerText = minutes<10 ? `0${minutes}` : minutes;
         secondsContainer.innerText = seconds<10 ? `0${seconds}` : seconds;
         daysDescription.innerText =  daysDesc;
         hoursDescription.innerText =  hoursDesc;
         minutesDescription.innerText =  minutesDesc;
         secondsDescription.innerText =  secondsDesc;

         // If the count down is finished, write some text
         if (distance < 0) {
             daysContainer.innerText = '0';
             hoursContainer.innerText = '0';
             minutesContainer.innerText = '0';
             secondsContainer.innerText = '0';
             clearInterval(x);
         }
     }
}

export default function startTimer(display) {
    const countdowns = document.querySelectorAll('.counter__clock');
    countdowns.forEach(display => {
        countdown(display);
    });
}
